import { parseSettlementStatus } from "../parseSettlementStatus";
import { isSettledStatus } from "../../helpers";
/**
 * Determines whether and how to render the Early Win tag on a given selection.
 * Returns undefined when the selection is not eligible for Early Win.
 *
 * Tag variant logic:
 * - Open + eligible: filled (active purple tag)
 * - Settled + EW triggered (isEarlyWinSettled): filled (confirmed win via EW)
 * - Settled + eligible + EW NOT triggered: subdued (eligible but didn't trigger)
 * - Not eligible: undefined (no tag)
 */
export function parseEarlyWinSelectionTag(selection, dictionary) {
    if (!selection.isEarlyWinEligible) {
        return undefined;
    }
    const status = parseSettlementStatus(selection.settlementStatus);
    const isSettled = isSettledStatus(status);
    let variant;
    if (!isSettled) {
        // Open selection: filled purple tag
        variant = "filled";
    }
    else if (selection.isEarlyWinSettled) {
        // Settled and EW triggered: filled purple tag
        variant = "filled";
    }
    else {
        // Settled but EW did NOT trigger: subdued purple tag
        variant = "subdued";
    }
    return {
        label: dictionary.myBetsDictionary.EarlyWin,
        variant,
    };
}
//# sourceMappingURL=parseEarlyWinSelectionTag.js.map